
import { Component, Prop, Vue } from 'vue-property-decorator'
import FormInput2 from '@/components/forms/FormInput2.vue'
import { reportFormValidity } from '@/helpers/Validation'
import { getApiErrorEntity } from '@/errors/helpers'
import { LanguageStrings } from '@/language/types'
import { languageItem } from '@/helpers/LanguageHelpers'
import { openModal } from '@/helpers/Modals'

// eslint-disable-next-line no-unused-vars
export function openCodeModal(message: string, applyCallback: (code: string) => void) {
  const t = languageItem('codeModal')

  openModal({
    name: 'code-modal',
    size: 'sm',
    component: CodeModal,
    title: t.title,
    props: {
      message,
      applyCallback,
    },
  })
}

@Component({
  name: 'CodeModal',
  components: { FormInput2 },
})
export default class CodeModal extends Vue {
  t: LanguageStrings['codeModal']

  @Prop({ required: true })
  message: string

  @Prop({ required: true })
  // eslint-disable-next-line no-unused-vars
  applyCallback: (code: string) => Promise<any>

  error: string | undefined = ''
  code = ''
  loading = false

  apply() {
    this.loading = true
    reportFormValidity(this.$refs.form as HTMLFormElement)
      .then(() => this.applyCallback(this.code))
      .then(() => this.$modals.close())
      .catch((err) => {
        // Ignore validation error
        if (!err.validationError) {
          const apiError = getApiErrorEntity(err)
          if (apiError) {
            this.error = apiError._description
          } else {
            throw err
          }
        }
      })
      .finally(() => (this.loading = false))
  }
}
